import React from 'react'
import PropTypes from 'prop-types'
import { About } from '../../../About'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const InfoCreditMileage = props => (
  <About title=' Sobre o pedido'>
    <div className='row product-brand pt-3  px-2'>
      <div className='col-12 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left  justify-content-center align-self-center '>
        <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          Transferência: <strong> {props.vendorName} </strong>
        </p>
        <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          Valor em reales: <CatalogCurrencyLabel value={props.sellingPrice} />
        </p>
        <p className='txt-body-sm txt-subtitle txt-font-body color-ui-2'>
          Valor em Créditos: <strong> {props.name} </strong>
        </p>
      </div>
    </div>
  </About>
)

InfoCreditMileage.propTypes = {
  vendorName: PropTypes.string,
  sellingPrice: PropTypes.number,
  name: PropTypes.number
}

export default InfoCreditMileage



// WEBPACK FOOTER //
// ./src/features/Services/ConfirmationCreditMileage/AboutCreditMileage/InfoCreditMileage.js